module.exports = __webpack_public_path__ + "img/空间剧本.ff73f608.webp";